exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-group[data-v-78c11a4d] {\n  background-color: rgba(255, 255, 255, 0.8);\n  height: 100%;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n.list-group-item > i[data-v-78c11a4d]:hover {\n  cursor: pointer;\n}\n.nutrients > .list-group-item[data-v-78c11a4d]:hover {\n  cursor: grab;\n}\n.list-group-item.sortable-ghost[data-v-78c11a4d] {\n  cursor: grabbing;\n}\n.nutrients-container[data-v-78c11a4d] {\n  height: 100%;\n}\n.progress-bar-container[data-v-78c11a4d] {\n  min-height: 76px;\n}\n.available-nutrients .list-group-item[data-v-78c11a4d] {\n  float: left;\n  width: 50%;\n}\n", ""]);

// exports
